import { useMemo } from 'react';

import { useJobContext } from 'pages/Job/context';

export interface JobActionButtonsHook {
  showRequestChangesButton: boolean;
  showApplyButton: boolean;
}

export default function useJobActionButtons(): JobActionButtonsHook {
  const { job, changesStatus } = useJobContext();

  const hasApplied = useMemo(() => {
    if (!job) return false;
    return Boolean(job.customer_options);
  }, [job]);

  const showApplyButton = useMemo(
    () => changesStatus !== 'REQUESTED',
    [changesStatus],
  );

  const showRequestChangesButton = useMemo(
    () => changesStatus !== 'REQUESTED' && !hasApplied,
    [changesStatus, hasApplied],
  );

  return {
    showRequestChangesButton,
    showApplyButton,
  };
}
